<template>
  <div class="fixed-wrapper" @click.self="$emit('close')">
    <div class="k-modal-window">
      <div class="loading-indication" v-if="busyState">
        <k-spinner />
      </div>
      <div
        @click="currentStep--"
        class="k-modal-window__arrow k-modal-window__arrow--left" 
        :class="{ disabled: isFirstStep(currentStep) }"
      >
        <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.4103 14.0568L2.57956 8.00002L9.4103 1.94324C9.71166 1.66793 9.71166 1.20908 9.4103 0.933775C9.10894 0.658466 8.60668 0.658466 8.20488 0.933775L0.771428 7.44941C0.470072 7.72471 0.470072 8.18356 0.771429 8.45887L8.10443 15.0663C8.40578 15.3416 8.90804 15.3416 9.30985 15.0663C9.71166 14.791 9.71166 14.3321 9.4103 14.0568Z" fill="white"/>
        </svg>
      </div>

      <go-back class="k-modal-go-back mb-2" text="Назад к меню" @click="$emit('close')"/>
      <div class="k-modal-window__wrapper">
        <div class="k-modal-steps mb-3">
          <div
            class="w-100 d-flex align-items-center"
            :class="{ 'w-auto': isLastStep(step) }"
            v-for="{ step, title } in steps"
            :key="step"
          >
            <popper
              trigger="hover"
              :options="{ placement: 'top' }"
            >
              <div class="popper k-modal-popper d-flex flex-column">
                <span class="k-modal-sticker__title">Шаг {{ step }}</span>
                <span class="k-modal-sticker__subtitle">{{ title }}</span>
              </div>

              <div slot="reference">
                <div
                  class="k-modal-steps__step"
                  :class="{ skip: currentStep > step, active: currentStep === step }"
                ></div>
              </div>
            </popper>
            <span class="k-modal-steps__linker" v-if="!isLastStep(step)"></span>
          </div>
        </div>
        <transition name="slide-fade" mode="out-in">
          <component 
            :is="getCurrentStepData.component"
            :data="getCurrentStepData.data"
            :steps="getAllStepData"
            :menuId="menuId"
            :promo="promo"
            @update="updateStepData"
            @next="currentStep++"
            @back="currentStep--"
            @pay="onPay"
            @promo="value => promo = value"
          ></component>
        </transition>
      </div>

      <div
        @click="currentStep++"
        class="k-modal-window__arrow k-modal-window__arrow--right" 
        :class="{ disabled: isLastStep(currentStep) || isCurrentStepEmptyData() }"
      >
        <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.589699 1.9432L7.42044 7.99998L0.5897 14.0568C0.288343 14.3321 0.288343 14.7909 0.5897 15.0662C0.891055 15.3415 1.39332 15.3415 1.79512 15.0662L9.22857 8.55059C9.52993 8.27529 9.52993 7.81644 9.22857 7.54113L1.89557 0.933732C1.59422 0.658423 1.09196 0.658423 0.690151 0.933732C0.288342 1.20904 0.288342 1.66789 0.589699 1.9432Z" fill="white"/>
        </svg>
      </div>
    </div>
    
  </div>
</template>

<script>
import GoBack from '../components/TheGoBack';
import BuyDishType from './BuySubscriptionTabs/BuyDishType';
import BuyTimeType from './BuySubscriptionTabs/BuyTimeType';
import BuySubscribeType from './BuySubscriptionTabs/BuySubscribeType';
import { buyRegularMenu, addUserToMenu } from '../api/SubscribeApi';
import { mapActions, mapGetters } from 'vuex';
import KSpinner from '../components/TheSpinner';

export default {
  components: {
    GoBack,
    KSpinner,
  },
  props: {
    menuId: {
      type: String,
      default: '',
    }
  },
  data: () => ({
    currentStep: 1,
    steps: [
      { step: 1, title: 'Приемы пищи', component: BuyDishType, data: [] },
      { step: 2, title: 'Дни питания', component: BuyTimeType, data: null },
      { step: 3, title: 'Тип подписки', component: BuySubscribeType, data: 1 },
    ],
    promo: '',
    busyState: false,
  }),
  computed: {
    ...mapGetters([
      'getUserFamily',
      "getUserSubscribes",
    ]),
    getCurrentStepData() {
      return this.steps.find(el => el.step === this.currentStep);
    },
    getAllStepData() {
      return this.steps;
    },
    getMainProfile() {
      return this.getUserFamily.find(el => el.is_main === 't');
    },
  },
  methods: {
    ...mapActions([
      'loadUser'
    ]),
    async onPay() {
      if (this.busyState) return;

      this.busyState = true;
      const current = this.getUserSubscribes.find(el => el.menu_id === this.menuId);

      if (current && current.is_paid === 'f') {
        const { data } = await buyRegularMenu({
          menu_id: this.menuId,
          meal_types: this.steps[0].data,
          periodicity:  this.steps[1].data,
          months_count: this.steps[2].data,
          promocode: this.promo ? this.promo.toUpperCase().trim() : undefined,
        }, true, current.id)

        if (data.data.subscription.confirmation_url) {
          location.href = data.data.subscription.confirmation_url
        } else {
          this.loadUser();
        }
      } else {
        const { data } = await buyRegularMenu({
          menu_id: this.menuId,
          meal_types: this.steps[0].data,
          periodicity:  this.steps[1].data,
          months_count: this.steps[2].data,
          promocode: this.promo ? this.promo.toUpperCase().trim() : undefined,
        })

        await addUserToMenu({
          profile_id: this.getMainProfile.id,
          subscription_id: data.data.subscription.id,
          meal_types: this.steps[0].data,
        });

        if (data.data.subscription.confirmation_url) {
          location.href = data.data.subscription.confirmation_url
        } else {
          this.loadUser();
        }
      }

      this.busyState = false;
      this.$emit('close');
    },
    isFirstStep(step) {
      return step === 1;
    },
    isLastStep(step) {
      return step === Math.max.apply(this, this.steps.map(el => el.step))
    },
    isCurrentStepEmptyData() {
      const current = this.getCurrentStepData;
      return Array.isArray(current.data) ? !current.data.length : !current.data;
    },
    updateStepData(data) {
      const current = this.getCurrentStepData;
      current.data = data;
    }
  }
}
</script>

<style lang="scss" scoped>
.fixed-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.15);
  z-index: 10;

  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 60px;
}

.k-modal-window {
  width: 100%;
  height: 100%;
  max-width: 820px;
  max-height: 680px;

  background: #FFFFFF;
  border: 1px solid #EBEBEB;
  box-sizing: border-box;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.05);
  border-radius: 2px;
  padding: 40px;

  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}

.k-modal-window__arrow {
  min-width: 40px;
  min-height: 40px;
  border-radius: 50%;
  background: #F7981E;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;

  &.disabled {
    background: #CFD2D3;
    pointer-events: none;
  }
}

.k-modal-go-back {
  display: none;
}

.k-modal-window__wrapper {
  width: 260px;
  height: 100%;
}

.k-modal-steps {
  width: 100%;
  display: flex;
}
.k-modal-steps__step {
  min-width: 26px;
  min-height: 26px;
  border-radius: 50%;
  background: #e4e4e4;
  position: relative;
  transition: all .25s linear;

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 65%;
    height: 65%;
    background: #fff;
    border-radius: 50%;
  }

  &.active {
    background: #fff;

    &::after {
      background: #F7981E;
      width: 45%;
      height: 45%;
    }
  }

  &.skip {
    background: #F7981E;

    &::after {
      content: unset;
    }
  }
}
.k-modal-steps__linker {
  height: 2px;
  background: #e4e4e4;
  width: 100%;
}

@media (max-width: 767.98px) {
  .k-modal-window__wrapper {
    padding-top: 70px;
  }
  .k-modal-window {
    padding: 10px !important;
    justify-content: center;
    max-height: unset;
    overflow-y: scroll;
    position: relative;
  }
  .k-modal-window__arrow {
    display: none;
  }
  .k-modal-go-back {
    display: block;
    height: 50px;
    padding-top: 10px;
    position: absolute;
    top: 25px;
    left: 20px;
  }
}
</style>

<style lang="scss">
.k-modal-button[disabled] {
  pointer-events: none;
  opacity: 0.7;
}
.k-modal-button,
.k-modal-sticker {
  width: 260px;
  height: 60px;
  background: #FFFFFF;
  border: 1px solid #CFD2D3;
  box-sizing: border-box;
  border-radius: 8px;
  color: #808080;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all .25s linear;
  cursor: pointer;

  &.selected {
    background: #F68C1E;
    color: #fff !important;
    border: unset;
  }
}

.k-modal-button {
  background: #FFCC1B;
  color: #fff;
  border: unset;

  &.disabled {
    background: #C4C4C4;
    opacity: 0.4;
  }

  &.green {
    background: #9dc43b;
  }
}
.k-modal-title {
  font-size: 20px;
  text-align: center;
  color: #000000;
}

.k-modal-sticker__title {
  font-weight: 600;
  font-size: 16px;
  text-align: center;
}
.k-modal-sticker__subtitle {
  font-weight: 600;
  font-size: 12px;
  text-align: center;
  opacity: 0.6;
}
.k-modal-popper {
  background: #FFFFFF;
  box-shadow: 0px -4px 20px rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  padding: 10px 20px;
  text-align: center;
}
.k-modal__back {
  position: absolute;
  top: 0;
  left: 0;
}
</style>